// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[role=tab]:focus-visible{outline-offset:calc(-1*var(--size-sm));outline:var(--focus-outline)}[role=tab][aria-selected=true]{text-decoration:underline}", ""]);
// Exports
module.exports = exports;
